import {
  Button,
  Divider,
  Flex,
  Stack,
  Text,
  Title,
  useMantineColorScheme,
} from '@mantine/core';
import { IconLock } from '@tabler/icons-react';
import { useNavigate } from 'react-router-dom';

const Forbidden = () => {
  const { colorScheme } = useMantineColorScheme();
  const navigate = useNavigate();

  return (
    <Flex
      mih={50}
      gap='md'
      justify='center'
      align='center'
      direction='row'
      wrap='wrap'
    >
      <Stack
        h={300}
        align='center'
        justify='center'
        gap='md'
        style={theme => ({
          backgroundColor:
            colorScheme === 'dark'
              ? theme.colors.dark[8]
              : theme.colors.gray[0],
        })}
      >
        <IconLock size={48} stroke={1.5} />
        <Title order={2} fw={500} style={{ textAlign: 'center' }}>
          403
        </Title>
        <Divider orientation='vertical' />
        <Text size='md' fw={500} style={{ textAlign: 'center' }}>
          Access Denied
        </Text>
        <Text size='sm' c='dimmed' style={{ textAlign: 'center' }}>
          You don't have permission to access this page.
        </Text>
        <Button variant='light' onClick={() => navigate('/')}>
          Go to Dashboard
        </Button>
      </Stack>
    </Flex>
  );
};

export default Forbidden;
